import React from 'react';

const NotificationBar = (props) => {
  return (
    <div className={`notification-bar ${props.notificationType} ${props.show ? 'active' : ''}`} dangerouslySetInnerHTML={{ __html: props.message }}>
    </div>
  );
};

export default NotificationBar;



// WEBPACK FOOTER //
// ./src/components/notification-bar/notification-bar.component.js